var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#2E3E36;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#40BA8E;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rounded_Rectangle_1_copy_74"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.9,42.9C33.7,42.8,34,43,33.9,42.9L33.9,42.9z M64.8,39.8c-1.1-1.1-3-0.9-3.9,0.4 c-2.4,3.5-6.7,5.9-11.4,5.9c-4.9,0-9.3-2.6-11.6-6.5l0,0c-0.1-0.3-0.3-0.6-0.6-0.9c-1-1-2.3-1-3.4-0.1c-1.3,1-1.3,2.4,0,4.3 c3.3,4.9,9.2,8.2,15.6,8.2c6.2,0,11.6-3,15-7.5c0.1-0.1,0.2-0.1,0.3-0.3C65.8,41.9,65.5,40.5,64.8,39.8z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Rounded_Rectangle_1_copy_12"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.4,84.7c0-4.6-2.2-8.7-5.7-11.3l0.1-0.1L63.8,57c9.4-4.9,15.9-14.8,15.9-26.2c0-16.3-13.2-29.6-29.6-29.6 c-16.3,0-29.6,13.2-29.6,29.6c0,11.6,6.6,21.6,16.3,26.4L10.3,73.3l0.1,0.1c-3.5,2.6-5.8,6.7-5.8,11.3c0,7.4,5.8,13.5,13.2,14.1 l0,0h64.8l0,0C90.2,98.6,96.4,92.4,96.4,84.7z M25.4,30.8c0-13.6,11.1-24.7,24.7-24.7c13.6,0,24.7,11.1,24.7,24.7 c0,13.6-11.1,24.7-24.7,24.7C36.5,55.4,25.4,44.4,25.4,30.8z M82.3,93.9L82.3,93.9l-64.3,0c-4.4-0.5-8.1-4.5-8.1-9 c0-3.3,2.2-6.3,5-7.8L14.8,77l28.9-17.4c2.1,0.5,4.3,0.7,6.5,0.7c2.4,0,4.8-0.3,7-0.9l29,17.5l0,0.1c2.8,1.5,5,4.5,5,7.8 C91.1,89.6,87,93.7,82.3,93.9z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.6465dd5d790c79b7b1c7d817a2b98d0f.svg";
export { ForwardRef as ReactComponent };